import { render, staticRenderFns } from "./DeliveriesPerWeek.vue?vue&type=template&id=bac03aea&"
import script from "./DeliveriesPerWeek.vue?vue&type=script&lang=js&"
export * from "./DeliveriesPerWeek.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports